import api from '@/helpers/api';

import type {
	CreateMissionPayload,
	CreateMissionResponse,
	UpdateMissionPayload,
} from '@/modules/companyNeed/components/modals/createOrder/types';
import type {
	AddWorkersToMissionBulkRequest,
	AddWorkersToMissionBulkStatusItem,
	CancelMissionData,
	ExtendMissionPayload,
	MissionModalData,
	UpdateMissionWorkerStatus,
	UpdateMissionWorkerStatusBulk,
} from '@/modules/companyNeed/types/missions';
import type { MissionList } from '@/modules/companyNeed/views/details/missions/types';

const createMission = async (
	payload: CreateMissionPayload
): Promise<CreateMissionResponse> => {
	const response = await api.request({
		url: '/missions',
		method: 'POST',
		data: payload,
	});
	return response.data;
};

const updateMission = async (
	missionId: string,
	payload: UpdateMissionPayload
): Promise<void> => {
	await api.request({
		url: `/missions/${missionId}`,
		method: 'PATCH',
		data: payload,
	});
};

const fetchMissions = async (
	besoinId: string,
	params?: { status?: string[]; search?: string }
): Promise<MissionList[]> => {
	const response = await api.request({
		url: `/missions/besoin/${besoinId}`,
		method: 'GET',
		params,
	});
	return response.data;
};

const fetchMissionDetails = async (
	missionId: string
): Promise<MissionModalData> => {
	const response = await api.request({
		url: `/missions/${missionId}`,
		method: 'GET',
	});
	return response.data;
};

const addWorkersToMissionBulk = async (
	missionId: string,
	data: AddWorkersToMissionBulkRequest
): Promise<AddWorkersToMissionBulkStatusItem[]> => {
	const response = await api.request({
		url: `/missions/${missionId}/workers/bulk`,
		method: 'POST',
		data,
	});
	return response.data;
};

const updateMissionWorkerStatusBulk = async (
	missionId: string,
	data: UpdateMissionWorkerStatusBulk
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
): Promise<any> => {
	const response = await api.request({
		url: `/missions/${missionId}/workers/bulk-status`,
		method: 'PATCH',
		data,
	});
	return response.data;
};

const updateMissionWorkerStatus = async (
	missionId: string,
	workerId: string,
	data: UpdateMissionWorkerStatus
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
): Promise<any> => {
	const response = await api.request({
		url: `/missions/${missionId}/workers/${workerId}`,
		method: 'PATCH',
		data,
	});
	return response.data;
};

const cancelMission = async (
	missionId: string,
	data: CancelMissionData
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
): Promise<any> => {
	const response = await api.request({
		url: `/missions/${missionId}/cancel`,
		method: 'POST',
		data,
	});
	return response.data;
};

const extendMission = async (
	missionId: string,
	data: ExtendMissionPayload
): Promise<CreateMissionResponse> => {
	const response = await api.request({
		url: `/missions/${missionId}/extend`,
		method: 'POST',
		data,
	});
	return response.data;
};

const validateMission = async (missionId: string): Promise<void> => {
	await api.request({ url: `/missions/${missionId}/validate`, method: 'POST' });
};

export default {
	createMission,
	updateMission,
	fetchMissions,
	fetchMissionDetails,
	addWorkersToMissionBulk,
	updateMissionWorkerStatusBulk,
	updateMissionWorkerStatus,
	cancelMission,
	extendMission,
	validateMission,
};
